import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { list as groupList } from '../../api/groups';
import { list as productList } from '../../api/products';
import { Button } from '../../components/Button';
import { ProductGroupItem } from '../../components/ProductGroupItem';
import { ProductItem } from '../../components/ProductItem';
import { SpinnerBlock } from '../../components/Spinner';
import { ProductsDetailsModal } from './ProductsDetailsModal';
import { ProductsGroupDetailsModal } from './ProductsGroupDetailsModal';
import S from './products.styl';
var ProductsView = /** @class */ (function (_super) {
    __extends(ProductsView, _super);
    function ProductsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            products: [],
            groups: [],
            loading: false,
            showCreateModal: false,
            showCreateGroupModal: false,
        };
        _this.onUpdate = function () {
            _this.fetchData();
        };
        _this.createAction = function () {
            _this.setState({
                editProduct: undefined,
                showCreateModal: true,
            });
        };
        _this.createGroupAction = function () {
            _this.setState({
                editGroup: undefined,
                showCreateGroupModal: true,
            });
        };
        _this.onCloseAdd = function () {
            _this.setState({
                showCreateModal: false,
                showCreateGroupModal: false,
            });
        };
        _this.isUpdatedAdd = function () {
            _this.setState({
                showCreateModal: false,
                showCreateGroupModal: false,
            });
            _this.fetchData();
        };
        _this.isEditClicked = function (product) {
            _this.setState({
                editProduct: product,
                showCreateModal: true,
            });
        };
        _this.isEditGroupClicked = function (group) {
            _this.setState({
                editGroup: group,
                showCreateGroupModal: true,
            });
        };
        return _this;
    }
    ProductsView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    ProductsView.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        productList().then(function (result) {
            _this.setState({
                loading: false,
                products: (result === null || result === void 0 ? void 0 : result.items) || [],
            });
        }).catch(function (error) {
            console.error(error);
        });
        groupList().then(function (result) {
            _this.setState({
                loading: false,
                groups: (result === null || result === void 0 ? void 0 : result.items) || [],
            });
        }).catch(function (error) {
            console.error(error);
        });
    };
    ProductsView.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var i18n = props.store.i18n;
        var _a = this.state, groups = _a.groups, loading = _a.loading, products = _a.products;
        return (React.createElement("div", { className: S.productsView },
            React.createElement("h1", { className: S.productsTitle }, i18n.productsTitle),
            React.createElement("hr", { className: S.productsSeparator }),
            React.createElement("div", { className: S.productsHeaderActions },
                React.createElement("span", null, i18n.productsGroupTitle),
                React.createElement(Button, { className: "primaryButton " + S.addButton, type: "button", onClick: this.createGroupAction }, i18n.actionCreate)),
            React.createElement("div", { className: S.productsMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: S.productsHeader },
                            React.createElement("div", { className: S.tableCell + " imageCell" }, i18n.inputTitleIcon),
                            React.createElement("div", { className: S.tableCell }, i18n.productsTitle),
                            React.createElement("div", { className: S.action }, i18n.productsAction)),
                        React.createElement("div", { className: S.productsUserList }, groups.map(function (group, i) { return (React.createElement(ProductGroupItem, { key: i, group: group, isUpdated: _this.onUpdate, isEditClicked: _this.isEditGroupClicked })); })))),
            this.state.showCreateGroupModal &&
                React.createElement(ProductsGroupDetailsModal, { onClose: this.onCloseAdd, isUpdated: this.isUpdatedAdd, editGroup: this.state.editGroup }),
            React.createElement("hr", { className: S.productsSeparator }),
            React.createElement("div", { className: S.productsHeaderActions },
                React.createElement("span", null, i18n.productsTitle),
                React.createElement(Button, { className: "primaryButton " + S.addButton, type: "button", onClick: this.createAction }, i18n.actionCreate)),
            React.createElement("div", { className: S.productsMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: S.productsHeader },
                            React.createElement("div", { className: S.tableCell + " idCell" }, "ID"),
                            React.createElement("div", { className: S.tableCell + " imageCell" }, i18n.inputTitleIcon),
                            React.createElement("div", { className: S.tableCell }, i18n.productsTitle),
                            React.createElement("div", { className: S.action }, i18n.productsAction)),
                        React.createElement("div", { className: S.productsUserList }, products.map(function (product, i) { return (React.createElement(ProductItem, { key: i, product: product, isUpdated: _this.onUpdate, isEditClicked: _this.isEditClicked })); })))),
            this.state.showCreateModal &&
                React.createElement(ProductsDetailsModal, { onClose: this.onCloseAdd, isUpdated: this.isUpdatedAdd, editProduct: this.state.editProduct, groups: groups })));
    };
    ProductsView = __decorate([
        inject('store'),
        observer
    ], ProductsView);
    return ProductsView;
}(React.Component));
export { ProductsView };
